import { Button, Container, Stack, Typography, Card, Box } from '@mui/material';
import { useEffect, useState } from 'react';
import { QrReader } from 'react-qr-reader';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useNavigate } from 'react-router-dom';
import { useFindByBookingIdMutation } from '../../store/api/bookingsApi';
import { formatDateTime } from '../../sections/@dashboard/parkingspaces/utility';
import Loading from '../../components/Loading';

export default function EnforcementQRScan() {
  const [data, setData] = useState<string | null>(null);
  const [showScanner, setShowScanner] = useState<boolean>(true);
  const [showData, setShowData] = useState<boolean>(false);
  const [responseData, setResponseData] = useState<any>();
  const [findByBookingId, BookingDataResponse] = useFindByBookingIdMutation();
  const authData = JSON.parse(localStorage.getItem('login') || '{}');
  const [selected, setSelected] = useState('environment');

  useEffect(() => {
    if (data && authData) {
      let bookingId = data.split('|');
      updateActualAsync(bookingId[0], authData.token);
    }
  }, [data]);

  const updateActualAsync = (data: string, token: string) => {
    findByBookingId({
      token: token,
      id: data,
    });
  };

  useEffect(() => {
    if (BookingDataResponse.isSuccess) {
      setShowScanner(false);
      setShowData(true);
      setResponseData(BookingDataResponse.data);
    }
  }, [BookingDataResponse.isSuccess]);

  return (
    <Container>
      <Stack direction="row" alignItems="center" justifyContent="space-between">
        {showScanner ? (
          <Typography variant="h4" gutterBottom>
            Scan QR Code
          </Typography>
        ) : (
          <Typography variant="h4" gutterBottom>
            Booking Information
          </Typography>
        )}
        <Button
          variant="contained"
          color="error"
          onClick={() => {
            setShowScanner(true);
            setShowData(false);
          }}
          sx={{ marginBottom: '10px' }}
          size="medium"
        >
          <ArrowBackIcon />
        </Button>
      </Stack>
      {showScanner && (
        <Box>
          <QrReader
            scanDelay={300}
            key="environment"
            onResult={(result, error) => {
              if (!!result) {
                setData(result.toString());
              }
              if (!!error) {
                console.info(error);
              }
            }}
            constraints={{ facingMode: selected }}
            containerStyle={{ width: '500px', height: '500px', border: '1px solid' }}
          />

          <Box style={{ width: '500px', textAlign: 'center' }}>
            <Button
              variant="contained"
              color="primary"
              onClick={() => {
                setSelected(selected == 'environment' ? 'user' : selected == 'user' ? 'environment' : 'user');
              }}
              sx={{ marginTop: '10px' }}
              size="medium"
            >
              Switch Camera
            </Button>
          </Box>
        </Box>
      )}
      {showData ? (
        <Card style={{ padding: '40px' }}>
          <Box className="qrcode" style={{ display: 'flex', flexDirection: 'row', marginTop: '20px', gap: '240px' }}>
            <Box>
              <Typography variant="h6">Customer Name: {responseData.customerDetailResponseDTO.name}</Typography>
            </Box>
            <Box>
              <Typography variant="h6">Booking Code: {responseData.bookingCode}</Typography>
            </Box>
          </Box>
          <Box className="qrcode" style={{ display: 'flex', flexDirection: 'row', marginTop: '20px', gap: '300px' }}>
            <Box>
              <Typography variant="h6">Booking Status: {responseData.bookingStatus}</Typography>
            </Box>
            <Box>
              <Typography variant="h6">
                Booking Date: {formatDateTime(responseData.bookingDate, 'DD/MM/yyyy, hh:mm A')}
              </Typography>
            </Box>
          </Box>
          <Box className="qrcode" style={{ display: 'flex', flexDirection: 'row', marginTop: '20px', gap: '200px' }}>
            <Box>
              <Typography variant="h6">
                Check-in Time:{' '}
                {responseData.checkinTime ? formatDateTime(responseData.checkinTime, 'DD/MM/yyyy, hh:mm A') : ''}
              </Typography>
            </Box>
            <Box className="qrcode" style={{ display: 'flex', flexDirection: 'row' }}>
              <Box className="qrcodemargin2">
                <Typography variant="h6">
                  Check-out Time : {formatDateTime(responseData.checkoutTime, 'DD/MM/yyyy, hh:mm A')}
                </Typography>
              </Box>
            </Box>
          </Box>
        </Card>
      ) : null}
      {BookingDataResponse.isLoading ? <Loading /> : null}
    </Container>
  );
}
